export const JOB_STATUSES = {
    OPEN:   'Open',
    DRAFT:   'Draft',
    ACTIVE: 'Active',
    ARCHIVED:   'Archived'
 }